<template>
  <div class="home" style=" padding-top: 70px;">
    <div class="homeStyle">
    <div class="homeStyleBg"></div>

    <div class="homeStyle1">
        <div>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item ,index) in webCarouselFigureList" :key="index">
                        <a :href="item.link" target="_blank">
                            <img  :src="item.fileUrl" /> 
                        </a>
                     </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination"></div>
            </div>
          
        </div>
    </div>
    <div class="new_index">
        <div class="htitle">
            <h2> 直播预告 </h2>
            <!-- <a href="/ZBTest/index" target="_blank">更多直播 &gt;</a> -->
            <router-link :to="{ name: 'LiveList' }">更多直播 &gt;</router-link>
        </div>
        <div class="banlist" id="live-list">
            <div class="zbyg" v-for="item in liveModelList"   @click="clickLiveUrl(item)">
                <a data-id="42">
                    <img :src="item.imageUrl" class="banlogo">
                    <div class="rt">
                        <div class="title" :title="item.title" style="margin-bottom:0;">{{item.title}}</div>
                        <div class="info1" style=" margin-bottom: 0; margin-top: 5px;">
                            <span class="txt" :title="item.content" style="height: 88px;"><pre style="background: none;color: #999;border: 0px;line-height: 18px;font-family: 微软雅黑;white-space: pre-line;font-size: 13px;">{{item.content}}</pre></span>
                        </div>
                        <div class="p_teacher" style="margin: 6px 0;line-height:16px;">
                            <span style="color: #333333;
                            font-size: 14px;
                            white-space: nowrap;
                            width: 100%;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;" :title="item.presenter">主讲人：{{item.presenter}} </span>
                        </div>
                        <div class="p_teacher"> 
                            <img src="images/icon-timelong.png" style="margin-top:-3px;"> 
                            <span style="color:#999;font-size:14px;"> {{ item.startTimeS }} - {{item.endTimeS}}</span>
                        </div>
                        <span class="statue" v-if="item.state==0" style="background: #699ef2;">未开始</span>
                        <span class="statue" v-if="item.state==1" style="background: #bd1b21;">进行中</span>
                        <span class="statue" v-if="item.state==2" style="background: #c3c7d7;">已结束</span>
                    </div> 
                </a>
            </div>
        </div>

    </div>
    <div class="new_index">
        <div class="htitle">
            <h2> 培训课程 </h2>
            <!-- <a href="/TrainCourse/index" target="_blank">更多课程 &gt;</a> -->
            <router-link :to="{ name: 'CourseList' }">更多课程 &gt;</router-link>
        </div>
        <div class="kcList" id="course-list">
            <a class="kebox" :data-id="item.id" v-for="item in  courseList" @click="clickKcUrl(item)">
                <p class="courseLabel">{{item.tags}}</p>
                <img :src="item.thumb" alt="" class="imgbg">
                <div class="kctitle" :title="item.title">{{item.title}}</div>
                <div class="nums">
                    <span class="teacher" v-if="item.teacherName">主讲人:{{item.teacherName}}</span>
                    <span class="stunum">
                        <img src="images/icon-scale.png"> 
                        <span> {{item.studentNum}}</span>
                    </span>
                <span class="startTime" v-if="item.startTimeS"> {{item.startTimeS}} 开课</span></div>
            </a>
        </div>
    </div>
    <div class="new_index" style="margin-bottom: 100px;">
        <div class="htitle">
            <h2> 培训项目 </h2>
            <!-- <a href="/class/index" target="_blank">更多培训 &gt;</a> -->
            <router-link :to="{ name: 'ClassList' }">更多培训 &gt;</router-link>
        </div>
        <div class="banlist" id="class-list">
            <div class="ban_item ban_item2" v-for="item in classModelList" @click="clickClassUrl(item)" >
                <a  :data-id="item.id">
                    <img :src="item.logo" class="banlogo">
                    <div class="rt">
                        <div class="title" :title="item.name">{{item.name}}</div>
                        <div class="info1">
                            <span class="txt" :title="item.summary">{{item.summary}}</span>
                        </div>
                        <div>
                            <div class="span1">
                                <img src="images/icon-scale.png">
                                <span> {{item.scale}}</span>
                            </div>
                            <div class="span3">
                                <img src="images/icon-type.png">
                                <span> {{item.category}}</span>
                            </div>
                            <div class="span2">
                                <img src="images/icon-timelong.png">
                                <span> {{item.startTimeS}}-{{item.endTimeS}}</span>
                            </div>
                        </div>
                    </div>
                 </a>
            </div>
        </div>

    </div>
    <!-- <div class="notice-box" v-show="!notice_close">
        <a class="colse" @click="closeNotice()"><img src="images/icon-close.png" /></a>
        <div class="ntitle">公告</div>
        <div class="nbody">
            <img src="images/jue.jpg" />
            师培在线平台目前已全新改版上线，新版APP全新升级开发中。<br />
            旧版PC端网站即日起迁移至：<a href="http://139.224.17.12:8011/" target="_blank">http://139.224.17.12:8011/</a>，将持续开放至2020年8月31日，旧版APP即日起暂停使用！欢迎各位老师前往PC端网站访问下载资料，给您带来不便，敬请谅解！<br />
            2020年6月29日
        </div>
    </div> -->
</div>
  </div>
</template>

<script>

//import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import comFun from "@/common/common";
import { Swiper } from 'swiper/swiper-bundle.esm.js'
import '../../public/css/swiper.css'
export default {
  name: "home",
  components: {
      //Swiper,
     // SwiperSlide
   },
//   directives: {
//     swiper: directive
//   },
  data(){
      return {
        // notice_close:true,
         classModelList:[],
         courseList:[],
         liveModelList:[],
         webCarouselFigureList:[],
         notice_close:0
      }
  },
 computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
 },
 created() {
        this.notice_close = window.sessionStorage.getItem("notice_close")
        comFun.geRecommendClass().then(res=>{ this.classModelList = res})
        comFun.geCourses().then(res=>{ this.courseList = res})
        comFun.geRecommendLives().then(res=>{ this.liveModelList = res})
        comFun.geCarouselFigures().then(res=>{ 
          this.webCarouselFigureList = res
          this.webCarouselFigureList.forEach(element => {
            var  protocol = document.location.protocol
            var str = element.link.split("://")
            if(protocol != str[0]+':')  element.link = protocol + '//' + str[1]  // 判断为http或者https
          });
          this.$nextTick(function(){
            if(this.webCarouselFigureList.length>1) this.initSwiper()
          })
        })
        // var that = this;
        
  },
  methods: {
    closeNotice(){
        window.sessionStorage.setItem("notice_close",1)
        this.notice_close = window.sessionStorage.getItem("notice_close")
    },
    initSwiper(){
        setTimeout(()=>{
          new Swiper('.swiper-container', {
            loopAdditionalSlides: 3,
            loop: true,
            speed: 2000,
            autoplay: {// 自动滑动
              delay: 5000, //1秒切换一次
              disableOnInteraction: false
            },
            pagination: {// 如果需要分页器
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            observer: true, 
            observeParents: true // 修改swiper的父元素时，自动初始化swiper
          });
        },300)
      },
    clickLiveUrl(item){
      if (!this.validLogined()) return false
      if(item.state ==2 && item.hasBackPlay==1)  comFun.playback(item)
      else if( item.state == 0 ||item.state ==  1) {   comFun.start(item)     }
      else if(item.hasBackPlay==undefined||item.hasBackPlay==0) {
        var msg = {
              type: 'error',
              text: '没有录制回放'
            }
            this.$store.dispatch('setMsg', msg)
      }
    },
    clickKcUrl(item){
        this.$router.push({
        name: 'CourseDetail',
        query: {
          id: item.id
        }
      })
    },
    clickClassUrl(item){
        console.log(item)
        this.$router.push({
        name: 'ClassDetail',
        query: {
          id: item.id
        }})
    },
    validLogined() { //验证是否登录
        if (this.userInfo == null) {
          this.$store.dispatch('setShowLogin', true)
          return false;
        } else {
          return true
        }
      },
  }
};
</script>

<style lang="scss" scoped>
.swiper {
height: 405px !important;
  width: 100%;

  .swiper  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    background-color: #fff;
  }

}

  .swiper-pagination{
    position: absolute;
    bottom: 10px;
    width: 100%;
    height: 20px;
  }
.swiper-pagination .swiper-pagination-bullet{   
    margin: 0 10px;
    width: 12px;
    height: 12px;
    border-radius: 6px;
}
</style>

